module.exports = __webpack_public_path__ + "img/hamburger-ico.6384c43f.svg";